<template>

        <div class="modal__overlay">

            <div class="modal-pedagogical">
                <div class="header">
                    <h4>{{ props.content.id ? $t('genially.EDIT_PEDAGOGICAL_CONTENT') : $t('genially.CREATE_PEDAGOGICAL_CONTENT') }}</h4>
                    <i class="material-icons" @click.stop="emit('close')">close</i>
                </div>
                <div class="select">
                    <Select 
                        v-model="configPedagogical.type"
                        mode="simple"
                        id="selectPedagogicalType"
                        :label="$t('genially.CONTENT_TYPE')"
                        valueProp="id"
                        valueLabel="name"
                        :values="configPedagogical.types"
                        :isDropdown="true"
                    />
                </div>
                <Input type="text" id="geniallyURL" :placeholder="$t('genially.LINK')" v-model="pedagogicalURL" :label="$t('genially.LINK')" />
                <div class="modal__buttons">
                    <button class="cancel" @click.stop="emit('close')">{{ $t('global.CANCEL') }}</button>
                    <button class="confirm" @click.stop="save()" :disabled="!pedagogicalURL || saving">{{ $t('global.SAVE') }}</button>
                </div>
            </div>

        </div>

    
</template>

<script setup>
import { onMounted, defineProps, defineEmits, ref } from 'vue';
import { useStore } from 'vuex';
import Select from '@/components/Inputs/Select.vue';
import Input from '@/components/Input.vue';
import { useI18n } from 'vue-i18n';


const store = useStore();

const props = defineProps({
    content: Object
});
const emit = defineEmits(['close','reload']);

const { t } = useI18n();


const saving = ref(false);

const configPedagogical = ref({
    type: "genially",
    types: [
        { id: "genially", name: "Genially", },
    ]
})

const pedagogicalURL = ref();

const save = async ()=> { 
    saving.value = true;
    let model = props.content;
    model.data.Data = `<div style="width: 100%;"><iframe style="width: 100%;" frameborder="0" width="1200" height="675" allowfullscreen="allowfullscreen" src="${pedagogicalURL.value}"></iframe></div>`;
    try {
        model.id
            ? await store.dispatch('contentEditor_editContent', model)
            : await store.dispatch('contentEditor_createContent', model);
        emit('reload');        
    } catch (error) {
        console.log(error);
        store.dispatch('notifications_create', { text: t('genially.ERROR_SAVING_CONTENT') });
    } finally {
        saving.value = false;
    }
}


onMounted(() => {
    if(props.content.id){
        let $div = document.createElement('div');
        $div.innerHTML = props.content.data.Data;
        let $iframe = $div.querySelector('iframe');
        let $src = $iframe.getAttribute('src');
        pedagogicalURL.value = $src;
        $div.remove();
    }
});


</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.modal__overlay{
    z-index: 1 !important;
}

.modal-pedagogical{
    .header{
        padding-bottom: 6px;
        display: flex;
        justify-content: space-between;
        i{
            cursor: pointer;
        }
    }
    width: 96%;
    max-width: 600px;
    max-width: 800px;
    max-height: 80vh;
    padding: 22px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 22px;
    border-radius: 10px;
    background: #FFF;
    box-shadow: 5px 5px 35px 0px rgba(217, 217, 217, 0.50);
    h4{
        padding-left: 4px;
    }
    .select{
        max-width: 240px;
    }
    .modal__buttons{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 24px;
        .cancel{
            border: none;
        }
    }
}

</style>